import type { DiffStatus, MatchResult, NumericTolerances } from '../../types'
import { calculateAmountImpact } from './amount'
import { compareBoqRows, hasChanges } from './fields'

export function computeDiffStatus(
  result: Pick<MatchResult, 'baselineRow' | 'targetRow' | 'confirmationState'>,
): DiffStatus {
  if (result.confirmationState === 'pending' || result.confirmationState === 'skipped')
    return 'pending'
  if (result.baselineRow === null) return 'added'
  if (result.targetRow === null) return 'removed'
  return hasChanges(compareBoqRows(result.baselineRow, result.targetRow)) ? 'changed' : 'unchanged'
}

export function finalizeDiffResult(
  result: MatchResult,
  tolerances: Partial<NumericTolerances> = {},
): MatchResult {
  let status: DiffStatus
  if (result.confirmationState === 'pending' || result.confirmationState === 'skipped')
    status = 'pending'
  else if (result.baselineRow === null) status = 'added'
  else if (result.targetRow === null) status = 'removed'
  else {
    const compared = compareBoqRows(result.baselineRow, result.targetRow, tolerances)
    status = hasChanges(compared) ? 'changed' : 'unchanged'
  }

  const fieldChanges = compareBoqRows(result.baselineRow, result.targetRow, tolerances)
  return {
    ...result,
    status,
    fieldChanges,
    amountImpact: calculateAmountImpact(result.baselineRow, result.targetRow, status),
  }
}

export function finalizeDiffResults(
  results: readonly MatchResult[],
  tolerances: Partial<NumericTolerances> = {},
): MatchResult[] {
  return results.map((result) => finalizeDiffResult(result, tolerances))
}
